import {useRoute} from "vue-router";
import {ref} from "vue";
import {itExist} from "@/utils/general-utils";
import ApiService, {ProductApi} from "@/api/apiService";

export default function useGetProductInformations() {
  const {params} = useRoute();
  const customerId = params?.customerId as string;
  const serialId = params?.serialId as string;
  const product = ref<ProductApi | null>(null);

  async function getProductInfo() {
    try {
      const customerData = await ApiService.getUser(customerId);
      const selectedProduct = customerData.products.filter((productItem: ProductApi) => productItem.reference === serialId)?.[0];

      if (!itExist(selectedProduct)) {
        throw 'no product';
      }

      product.value = selectedProduct;
    } catch (error) {
      window.close();
    }
  }

  return {
    product,
    getProductInfo,
  };
}
